exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.floating-button[data-v-cc486516]{\n  position: fixed;\n  z-index: 9999;\n  background: #03a9f4;\n  bottom: 40px;\n  right: 40px;\n  /* height: 30px; */\n  padding: 10px 14px;\n  font-size: 20px;\n  border-radius: 50%;\n}\n.badge-text[data-v-cc486516]{\n  position: absolute;\n  top: 0px;\n  left: 36px;\n  background: #f44336;\n  color: wheat;\n  border-radius: 10px;\n  font-size: 11px;\n  padding: 0 4px;\n}\n", ""]);

// exports
